








import BaseForm from '@/views/BaseForm';
import { Component } from 'vue-property-decorator';
import GoogleMap from '@/components/GoogleMap.vue';

@Component({
    name: 'pmap',
    components: { GoogleMap },
    head: {
        title: {
            inner: 'マップ',
            separator: '-',
            complement: 'Battery-Surveillance',
        },
    },
})
export default class pmap extends BaseForm {
    private selectGroup: number = 0; // 選択グループ

    get refs(): any {
        return this.$refs;
    }

    // 住所検索(GoogleMap.vueのイベントを呼び出し)
    private moveAddress(searchAddress: string) {
        this.refs.gmap.moveAddress(searchAddress);
    }

    // グループ検索
    private searchGroup(group_id: number) {
        this.refs.gmap.searchGroup(group_id);
    }
}
